<div [formGroup]="form">
  <div *ngIf="indexRow === null">
    <mat-label class="label-form">{{ meta.label }}:</mat-label>
    <mat-form-field
      [ngClass]="control.invalid && submitted ? 'invalid-field' : ''"
      appearance="fill"
      class="date-input w-full"
    >
      <mat-label>Scegli mese e anno</mat-label>
      <input
        (dateChange)="customActionInput($event)"
        *ngIf="meta.maxDateToday"
        [formControlName]="meta.key"
        [matDatepicker]="picker"
        [max]="today"
        matInput
        placeholder="MM/YYYY"
      />
      <input
        (dateChange)="customActionInput($event)"
        *ngIf="!meta.maxDateToday"
        [formControlName]="meta.key"
        [matDatepicker]="picker"
        matInput
        placeholder="MM/YYYY"
      />
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker
        #picker
        (monthSelected)="setMonthAndYear($event, picker)"
        panelClass="month-picker"
        startView="multi-year"
      ></mat-datepicker>
    </mat-form-field>
  </div>
  <app-box-errors [control]="control" [meta]="meta" [submitted]="submitted"></app-box-errors>
</div>
